<template>
  <v-layout column class="h100">
    <v-flex md12 ml-2>
      <v-card class="h-100">
        <v-card-text class="h-100">
          <transition name="fade-effect" mode="out-in">
            <!-- 2-->
            <skeleton-box v-if="isSearching || step < 1" class="h-100" key="skeleton-box" :flat="true">
              <v-layout class="h-100" row wrap>
                  <v-flex md6>
                    <skeleton-line 
                      class="skeleton-line-custom">
                    </skeleton-line>
                    <skeleton-line 
                      class="mt-5 skeleton-line-custom">
                    </skeleton-line>
                    <skeleton-line 
                      class="mt-5 skeleton-line-custom">
                    </skeleton-line>
                    <skeleton-line 
                      class="mt-5 skeleton-line-custom">
                    </skeleton-line>
                  </v-flex>
                  <v-flex md6>
                    <avatar-skeleton class="ml-5 mt-5" size="200px"></avatar-skeleton>
                    <skeleton-line class="skeleton-button-custom">
                    </skeleton-line>
                  </v-flex>
              </v-layout>
            </skeleton-box>
            <v-layout key="context-box" v-else class="h-100" row wrap>
              <v-flex md6>
                <v-layout column justify-space-around>
                  <v-flex v-for="(type, i) in data" :key="`type-${i}`">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout @click="showModal(i + 1)" class="row wrap borders card--hover">
                          <v-flex md2>
                            <v-icon style="font-size: 12px;">
                              {{type.icon}}
                            </v-icon>
                          </v-flex>
                          <v-flex md7>
                            <span>
                              {{ type.title }}
                            </span>
                          </v-flex>
                          <v-flex md3>
                            <span>
                              {{ Intl.NumberFormat('es-VE').format(type.total) }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 :key="`icon-${i}`" v-if="(i + 1) < data.length" class="text-xs-center mb-1 mt-1">
                        <v-icon>
                          fas fa-angle-down
                        </v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex md6>
                <pie 
                    height="100%" 
                    width="100%" 
                    :data="dataPie"
                    @update-step="$emit('update-step', $event)"
                    :step="step"
                    @show-status="showStatus = true"
                    v-if="this.dataPie[0].value > 0 || this.dataPie[1].value > 0"/>
                <template v-else>
                  <v-layout  class="h-100 align-center text-xs-center">
                    <v-flex>
                      <span>
                        No hay gestiones
                      </span>
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>
              <span class="caption font-weight-thin dateUpdate">
                {{date}}
              </span>
              <v-btn class="btn-historic" @click="showHistoric = true">
                Histórico
              </v-btn>
            </v-layout>
          </transition>
        </v-card-text>
      </v-card>
    </v-flex>
    <info :filters="filters"
      :show="dialog"
      v-if="dialog"
      @change-value="dialog = $event"
      :id="id"/>
    <status :filters="filters"
      :show="showStatus"
      v-if="showStatus"
      @change-value="showStatus = $event"/>
    <historic :filters="filters"
      :show="showHistoric"
      v-if="showHistoric"
      @change-value="showHistoric = $event"/>
  </v-layout>
</template>
<script>
import AvatarSkeleton from '@/components/global/skeletons/Avatar';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import SkeletonLine from '@/components/global/skeletons/Line';
import Pie from './Pie';
import Info from './Info';
import Status from './Status';
import Historic from './Historic';

export default {
  components: {
    Pie,
    Info,
    Status,
    Historic,
    SkeletonBox,
    SkeletonLine,
    AvatarSkeleton,
  },
  props: {
    date: {
      type: String,
      default: 'Buscando...',
    },
    step: {
      type: Number,
      default: 0,
    },
    isSearching: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      required: true,
    },
    dataPie: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showHistoric: false,
      showStatus: false,
      dialog: false,
      id: 0,
    };
  },
  methods: {
    showModal(id) {
      this.id = id;
      this.dialog = true;
    },
  },
};
</script>
<style scoped>

.borders {
  font-size: 12px;
  padding: 5%;
  border: 1px solid #d7d7d7;
  border-width: 0.3px;
}
.h100 {
  height: 100%;
}
.h100.layout {
  margin: 0!important;
}
.h100.layout > .flex {
  padding: 0!important;
}
.btn-historic {
  position: absolute;
  bottom: 4vh;
  box-shadow: none;
  right: 0px;
  border: 1px solid #d7d7d7;
}
.skeleton-line-custom {
  height: 50px;
}
.skeleton-line-custom, .skeleton-button-custom{
  border-radius: 0 !important;
}
.skeleton-button-custom {
  width: 8vw;
  height: 5vh;
  position: absolute;
  right: 0;
  bottom: 0;
}
.dateUpdate {
  position: absolute;
  bottom: 2vh;
  right: 1vw;
}
</style>





// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/DailyLoad/Index.vue